var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncursionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 19.3327H12.9167L15.3072 16.941L11.6567 13.2893L13.3017 11.6443L16.9534 15.2948L19.3334 12.916V19.3327ZM2.31169 19.3327L0.666687 17.6877L15.2967 3.04602L12.9167 0.666016H19.3334V7.08268L16.9534 4.70268L2.31285 19.3327H2.31169ZM6.69835 8.34268L0.666687 2.31102L2.31169 0.666016L8.35502 6.69768L6.69835 8.34151V8.34268Z",
    fill: "#c59d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncursionIcon);
export default __webpack_public_path__ + "static/media/incursion-icon.3a8ac7c44121d595c8ea4b0d446e1c63.svg";
export { ForwardRef as ReactComponent };